import styled from 'styled-components';

export const GroupView = styled.div`
  /*display: flex;*/
  max-width: 100vw;
  width: 100%;
`;
